import CheckSVG from '@public/icons/check.svg';
import CopySVG from '@public/icons/copy.svg';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {};

const ConfiguratorCopyConfigButton = (props: Props) => {
    const timer = useRef<NodeJS.Timeout>();
    const [success, setSuccess] = useState(false);

    const copyConfig = async () => {
        await navigator.clipboard.writeText(window.location.href);
    };

    return (
        <button
            {...props}
            className={classNames('configurator-copy-config-btn', props.className)}
            aria-label="Скопировать конфигурацию"
            onClick={async () => {
                clearTimeout(timer.current);
                setSuccess(false);
                try {
                    await copyConfig();
                    setSuccess(true);

                    timer.current = setTimeout(() => {
                        setSuccess(false);
                    }, 5000);
                } catch (err) {
                    console.error('Не удалось скопировать конфигурацию', err);
                }
            }}
        >
            {success ? (
                <CheckSVG className="configurator-copy-config-btn__icon" />
            ) : (
                <CopySVG className="configurator-copy-config-btn__icon" />
            )}
        </button>
    );
};

export default ConfiguratorCopyConfigButton;
